import { LocalDate } from "@js-joda/core";

type NumberedSalaryCutOffDay =
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20;

const NUMBERED_CUT_OFF_DAYS: readonly NumberedSalaryCutOffDay[] = [
  10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
];

export type SalaryCutOffDay = 0 | NumberedSalaryCutOffDay;

export function getSalaryCutOffDay(value: string | undefined): SalaryCutOffDay {
  const day = Number(value);
  return NUMBERED_CUT_OFF_DAYS.find((cutOffDay) => cutOffDay === day) ?? 0;
}

interface SalaryCutOffDateParams {
  readonly cutOffDay: SalaryCutOffDay;
  readonly period: LocalDate;
}

/**
 * The calendar-month setting (cutOffDay 0) closes on the final day of the
 * preceding month. A numbered cut-off day instead belongs to the salary
 * notice month itself.
 */
export function getSalaryCutOffDate({
  cutOffDay,
  period,
}: SalaryCutOffDateParams): LocalDate {
  if (cutOffDay === 0) {
    const workPeriod = period.minusMonths(1);
    return workPeriod.withDayOfMonth(workPeriod.lengthOfMonth());
  }
  return LocalDate.of(period.year(), period.monthValue(), cutOffDay);
}

interface SalaryCutOffComparisonParams {
  readonly cutOffDay: SalaryCutOffDay;
  readonly period: LocalDate;
  readonly today: LocalDate;
}

export function isOnOrBeforeSalaryCutOff({
  cutOffDay,
  period,
  today,
}: SalaryCutOffComparisonParams): boolean {
  return !today.isAfter(getSalaryCutOffDate({ cutOffDay, period }));
}

interface CurrentOrPastMonthParams {
  readonly month: LocalDate;
  readonly today: LocalDate;
}

export function isCurrentOrPastMonth({
  month,
  today,
}: CurrentOrPastMonthParams): boolean {
  return (
    month.year() < today.year() ||
    (month.year() === today.year() && month.monthValue() <= today.monthValue())
  );
}
